<sn-button-group>
  <ng-container *ngFor="let item of buttons; trackBy: trackByIdFn" [ngSwitch]="item.type">
    <ng-template [ngIf]="item.menu" [ngIfElse]="withoutMenu">
      <button
        mat-button
        *ngSwitchCase="'Button'"
        [disabled]="item.disabled"
        [color]="item.color"
        [snBadge]="item.badge?.value"
        [snSmartBadge]="item.badge?.name"
        [snBadgeColor]="item.badge?.color"
        [snBadgePositionX]="item.badge?.positionX"
        [snBadgePositionY]="item.badge?.positionY"
        [matTooltip]="item.tooltip?.message"
        [matTooltipPosition]="item.tooltip?.position"
        [matTooltipDisabled]="item.tooltip?.disabled()"
        [matTooltipShowDelay]="item.tooltip?.showDelay"
        [matTooltipHideDelay]="item.tooltip?.hideDelay"
        [matMenuTriggerFor]="menu"
      >
        <ng-container *ngTemplateOutlet="icon; context: { icon: item.icon }"></ng-container>
      </button>

      <button
        mat-flat-button
        *ngSwitchCase="'Flat Button'"
        [disabled]="item.disabled"
        [color]="item.color"
        [snBadge]="item.badge?.value"
        [snSmartBadge]="item.badge?.name"
        [snBadgeColor]="item.badge?.color"
        [snBadgePositionX]="item.badge?.positionX"
        [snBadgePositionY]="item.badge?.positionY"
        [matTooltip]="item.tooltip?.message"
        [matTooltipPosition]="item.tooltip?.position"
        [matTooltipDisabled]="item.tooltip?.disabled()"
        [matTooltipShowDelay]="item.tooltip?.showDelay"
        [matTooltipHideDelay]="item.tooltip?.hideDelay"
        [matMenuTriggerFor]="menu"
      >
        <ng-container *ngTemplateOutlet="icon; context: { icon: item.icon }"></ng-container>
      </button>

      <sn-outline-button
        *ngSwitchCase="'Outline Button'"
        [disabled]="item.disabled"
        [color]="item.color"
        [snBadge]="item.badge?.value"
        [snSmartBadge]="item.badge?.name"
        [snBadgeColor]="item.badge?.color"
        [snBadgePositionX]="item.badge?.positionX"
        [snBadgePositionY]="item.badge?.positionY"
        [matTooltip]="item.tooltip?.message"
        [matTooltipPosition]="item.tooltip?.position"
        [matTooltipDisabled]="item.tooltip?.disabled()"
        [matTooltipShowDelay]="item.tooltip?.showDelay"
        [matTooltipHideDelay]="item.tooltip?.hideDelay"
        [matMenuTriggerFor]="menu"
      >
        <ng-container *ngTemplateOutlet="icon; context: { icon: item.icon }"></ng-container>
      </sn-outline-button>

      <button
        mat-icon-button
        *ngSwitchCase="'Icon'"
        [disabled]="item.disabled"
        [color]="item.color"
        [snBadge]="item.badge?.value"
        [snSmartBadge]="item.badge?.name"
        [snBadgeColor]="item.badge?.color"
        [snBadgePositionX]="item.badge?.positionX"
        [snBadgePositionY]="item.badge?.positionY"
        [matTooltip]="item.tooltip?.message"
        [matTooltipPosition]="item.tooltip?.position"
        [matTooltipDisabled]="item.tooltip?.disabled()"
        [matTooltipShowDelay]="item.tooltip?.showDelay"
        [matTooltipHideDelay]="item.tooltip?.hideDelay"
        [matMenuTriggerFor]="menu"
      >
        <ng-container *ngTemplateOutlet="icon; context: { icon: item.icon }"></ng-container>
      </button>

      <mat-menu #menu="matMenu" [xPosition]="item.menu.positionX" [yPosition]="item.menu.positionY">
        <sn-menu [items]="item.menu.items"></sn-menu>
      </mat-menu>
    </ng-template>

    <ng-template #withoutMenu>
      <button
        mat-button
        *ngSwitchCase="'Button'"
        [disabled]="item.disabled"
        [color]="item.color"
        [snBadge]="item.badge?.value"
        [snSmartBadge]="item.badge?.name"
        [snBadgeColor]="item.badge?.color"
        [snBadgePositionX]="item.badge?.positionX"
        [snBadgePositionY]="item.badge?.positionY"
        [matTooltip]="item.tooltip?.message"
        [matTooltipPosition]="item.tooltip?.position"
        [matTooltipDisabled]="item.tooltip?.disabled()"
        [matTooltipShowDelay]="item.tooltip?.showDelay"
        [matTooltipHideDelay]="item.tooltip?.hideDelay"
        (click)="onButtonClick($event, item)"
      >
        <ng-container *ngTemplateOutlet="icon; context: { icon: item.icon }"></ng-container>
      </button>

      <button
        mat-flat-button
        *ngSwitchCase="'Flat Button'"
        [disabled]="item.disabled"
        [color]="item.color"
        [snBadge]="item.badge?.value"
        [snSmartBadge]="item.badge?.name"
        [snBadgeColor]="item.badge?.color"
        [snBadgePositionX]="item.badge?.positionX"
        [snBadgePositionY]="item.badge?.positionY"
        [matTooltip]="item.tooltip?.message"
        [matTooltipPosition]="item.tooltip?.position"
        [matTooltipDisabled]="item.tooltip?.disabled()"
        [matTooltipShowDelay]="item.tooltip?.showDelay"
        [matTooltipHideDelay]="item.tooltip?.hideDelay"
        (click)="onButtonClick($event, item)"
      >
        <ng-container *ngTemplateOutlet="icon; context: { icon: item.icon }"></ng-container>
      </button>

      <button
        mat-raised-button
        *ngSwitchCase="'Outline Button'"
        [disabled]="item.disabled"
        [color]="item.color"
        [snBadge]="item.badge?.value"
        [snSmartBadge]="item.badge?.name"
        [snBadgeColor]="item.badge?.color"
        [snBadgePositionX]="item.badge?.positionX"
        [snBadgePositionY]="item.badge?.positionY"
        [matTooltip]="item.tooltip?.message"
        [matTooltipPosition]="item.tooltip?.position"
        [matTooltipDisabled]="item.tooltip?.disabled()"
        [matTooltipShowDelay]="item.tooltip?.showDelay"
        [matTooltipHideDelay]="item.tooltip?.hideDelay"
        (click)="onButtonClick($event, item)"
      >
        <ng-container *ngTemplateOutlet="icon; context: { icon: item.icon }"></ng-container>
      </button>

      <button
        mat-icon-button
        *ngSwitchCase="'Icon'"
        [disabled]="item.disabled"
        [color]="item.color"
        [snBadge]="item.badge?.value"
        [snSmartBadge]="item.badge?.name"
        [snBadgeColor]="item.badge?.color"
        [snBadgePositionX]="item.badge?.positionX"
        [snBadgePositionY]="item.badge?.positionY"
        [matTooltip]="item.tooltip?.message"
        [matTooltipPosition]="item.tooltip?.position"
        [matTooltipDisabled]="item.tooltip?.disabled()"
        [matTooltipShowDelay]="item.tooltip?.showDelay"
        [matTooltipHideDelay]="item.tooltip?.hideDelay"
        (click)="onButtonClick($event, item)"
      >
        <ng-container *ngTemplateOutlet="icon; context: { icon: item.icon }"></ng-container>
      </button>
    </ng-template>
  </ng-container>
</sn-button-group>

<ng-template #icon let-icon="icon">
  <mat-icon
    *ngIf="icon"
    (icon)="(icon.icon)"
    [fontSet]="icon.fontSet"
    [fontIcon]="icon.fontIcon"
    (fontIconUnicode)="(icon.fontIconUnicode)"
    [svgIcon]="icon.svgIcon"
  >
  </mat-icon>
</ng-template>
